"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "title1ClassNames", {
    enumerable: true,
    get: function() {
        return _useTitle1Stylesstyles.title1ClassNames;
    }
});
const _export_star = require("@swc/helpers/_/_export_star");
_export_star._(require("./Title1"), exports);
const _useTitle1Stylesstyles = require("./useTitle1Styles.styles");
